import { PayloadAction } from '../../../store.model';
import { ActionType } from '../focus-selector.action';
import { FocusSelectorState } from '../focus-selector.state';
import { reusableGridSort } from '../grid/reusable-grid.function';

import { FocusSelectorSortClosedForPerformerGrid } from './closed-for-performer-sort.action';

export function focusSelectorSortClosedForPerformerGridReducer(
    state: FocusSelectorState,
    action: PayloadAction<ActionType, FocusSelectorSortClosedForPerformerGrid>,
): FocusSelectorState {
    const { column } = action.payload;
    const { sortDefs, defaultSortDefs } =
        state.recentlyClosedFocusesPerformerGrid;
    const nextSortDefs = reusableGridSort(column, sortDefs, defaultSortDefs);

    return {
        ...state,

        recentlyClosedFocusesPerformerGrid: {
            ...state.recentlyClosedFocusesPerformerGrid,
            sortDefs: nextSortDefs,
        },
    };
}
